// src/Login.js
import React, { useState } from "react";
import "./login.css";
import { useEffect } from "react";
import axios from "axios";
import { base_url } from "../counsellor/userReviews";
import { useAuth } from "../../utils/authContext";
import { useNavigate } from "react-router-dom";
import { emailRegex, specialChar } from "../../utils/constants";
import { usePassAuth } from "../../utils/passwordContext";
import { AdminStore } from "../../utils/store";
const ForgotPassword = () => {
  const { toggle_change_password } = AdminStore();
  const {setIsAuthenticated}=usePassAuth()
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpField, setOtpField] = useState(false);
  const [changePass, setChangePass] = useState();
  const navigate = useNavigate();
  
  const handleEmailValidation = () => {
    const newErrors = {};

    if (!email || email == "") newErrors.email = "Email is required";
    else if (!emailRegex.test(email)) newErrors.email = "Enter a valid email";
    setErrors(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  const handleOTPValidation = () => {
    const newErrors = {};
    if (!otp || otp == "") newErrors.otp = "OTP is required";
    else if (!specialChar.test(email)) newErrors.otp = "Enter a valid OTP";
    setErrors(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const timeoutId = setTimeout(() => {
        setErrors({});
      }, 5000);

      // Clean up the timeout on component unmount
      return () => clearTimeout(timeoutId);
    }
  }, [errors]);
  const get_otp = () => {
    let flag = handleEmailValidation();
    if (flag) {
      setLoading(true);
      axios
        .post(base_url + "/send-otp", { email: email })
        .then((res) => {
          setOtpField(true);
          setLoading(false);
        })
        .catch((err) => {
            let  errors={}
            errors.email = err.response.data;
            console.log("errors=======",errors)
          setErrors(errors);
          setLoading(false);
        });
    }
  };
  const verify_otp = () => {
    let flag = handleOTPValidation();
    if (flag) {
      setLoading(true);
      axios
        .post(base_url + "/verify-otp", { email: email, otp: otp })
        .then((res) => {
          if (res.status == 200) {
            setChangePass(true);
            setIsAuthenticated(true)
            // toggle_change_password(true)
          }
          setLoading(false);
          
        })
        .catch((err) => {
          err.otp = err.response.data;
          //   alert('Error on otp')
          setErrors(err);
          setLoading(false);
        });
    }
  };
  const reset_state = () => {
    setEmail("");
    setOtp("");
    setOtpField(false);
  };
  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Forgot Password</h2>
        <div className="input-container-login">
          <input
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={otpField || loading || changePass}
          />
          {errors?.email && (
            <span className="login-errors">{errors?.email}</span>
          )}
        </div>
        {otpField && (
          <div className="input-container-login">
            <input
              type="otp"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              max={6}
              maxLength={6}
              disabled={loading || changePass}
            />
            {errors?.otp && <span className="login-errors">{errors?.otp}</span>}
          </div>
        )}

        <button
          onClick={otpField ? verify_otp : get_otp}
          style={{ marginTop: "10px" }}
          disabled={loading || changePass}
        >
          {otpField ? "Verify OTP" : "Get OTP"}
        </button>
        {otpField && (
          <button
            onClick={() => {
              reset_state();
            }}
            style={{ marginTop: "10px" }}
            disabled={loading || changePass}
          >
            {"Change E-mail"}
          </button>
        )}
        {changePass && (
          <button
            onClick={() => {
              navigate("/change-password");
            }}
            style={{ marginTop: "10px" }}
            // disabled={loading ||changePass}
          >
            {"Change Password  ->"}
          </button>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
